import lang from '@/lang'
const ORG_TYPE = {
  CUSTOMER: {
    TXT: lang.t('customer'),
    CODE: 'CUSTOMER'
  },
  PARTNER: {
    TXT: lang.t('partner'),
    CODE: 'PARTNER'
  },
  // MANAGEMENT_TEAM: {
  //   TXT: lang.t('cloudTeam'),
  //   CODE: 'MANAGEMENT_TEAM'
  // },
  HEAD_OFFICE: {
    TXT: lang.t('headOffice'),
    CODE: 'HEAD_OFFICE'
  }
}

ORG_TYPE.isCustomer = type => {
  return type === ORG_TYPE.CUSTOMER.CODE
}
ORG_TYPE.isPartner = type => {
  return type === ORG_TYPE.PARTNER.CODE
}
// ORG_TYPE.iscloudTeam = type => {
//   return type === ORG_TYPE.MANAGEMENT_TEAM.CODE
// }
ORG_TYPE.isHeadOffice = type => {
  return type === ORG_TYPE.HEAD_OFFICE.CODE
}
ORG_TYPE.getLabel = type => {
  return type ? ORG_TYPE[type].TXT : '--'
}
ORG_TYPE.getFilterArr = () => {
  const resArr = []
  Object.values(ORG_TYPE).map(item => {
    if (typeof item !== 'function') {
      resArr.push({
        text: item.TXT,
        value: item.CODE
      })
    }
  })

  return resArr
}
export default ORG_TYPE
